// extracted by mini-css-extract-plugin
module.exports = {"description":"ResultsAccordion_description__3OVuM"};